<template lang="pug">
	.persistent-schedule-menu-notifier
		DxDropDownButton.no-text(
			icon="far fa-bell",
			:showArrowIcon="false"
			:items="jobs",
			display-expr="message",
			key-expr="id",
			:drop-down-options="{ width: 230 }"
			width="28px",
			height="28px",
			styling-mode="text",
			:focusStateEnabled="false",
			:wrapItemText="true",
			:noDataText="$tCaption('No jobs for last 24 hours')",
			:hint="$tCaption('Jobs')"
		)
			template(v-slot:item="{ data }")
				.no-jobs.flex-col.space.font-small.wrap(v-if="data.id === 'nojobs'")
					.grey {{ $tCaption('No jobs for last 24 hours.') }}
				.no-jobs.flex-col.space.font-small.wrap(v-else-if="data.id === 'journal'", @click="openAllJobs")
					.flex-row.justify-end
						a.hoverable.clickable.flex-row.space.align-center
							span {{ $tCaption('Open journal') }}
							fas(icon="arrow-right", size="xs")
				.job-message.flex-row.space-medium.align-center(v-else-if="data.isJob", @click="openJob(data)")
					.icon-status(:class="[getStatusByValue(data.Status, ['grey', 'grey', 'success-colored', 'error-colored'])]")
						fas(:icon="getStatusByValue(data.Status, ['clock', 'spinner', 'check', 'triangle-exclamation'])", :spin="data.Status === 2")
					.flex-col
						.font-mini.upper.grey.time {{data.Date}}
						.flex-row.space-medium.align-center.full-width
							.job-item-text(v-html="data.Description")
				.flex-col.center.align-center.full-height(v-else)
					.job-notification-icon
						fas(icon="clock")
					LoadingLine.full-width(v-if="hasAnyProcessing")
		Popup(v-if="editingJobPopupVisible", :popupVisible.sync="editingJobPopupVisible", :width="920", :autosize="true", :title="$tCaption('Job details')")
			.content
				JobDetail(:jobData="editingJob")
			template(slot="actions-right")
				DxButton(:text="$tCaption('Close', '@actions')", @click="editingJobPopupVisible = false")
</template>

<script>

import _ from 'lodash';
import DxDropDownButton from 'devextreme-vue/drop-down-button';
import ListView from 'app-core/ListView.vue';
import DxButton from 'devextreme-vue/button';
import { 
	PERSISTENT_SCHEDULE_JOB_STATUS
} from 'app-core/constants';
import Loader from 'app-core/Loader';
import Popup from 'app-core/Popup.vue';
import JobDetail from './Detail.vue';
import LoadingLine from 'app-core/LoadingLine.vue';

export default {
	translationCategory: 'persistent-schedule.List',
	components: { ListView, DxButton, Loader, Popup, JobDetail, DxDropDownButton, LoadingLine },
	props: [],
	data() {
		const jobStatuses = PERSISTENT_SCHEDULE_JOB_STATUS.toLocale('name', this);
		return {
			jobStatuses,
			isLoading: false,
			editingJob: null,
			editingJobPopupVisible: false,
			loadedJobs: []
		};
	},
	computed: {
		jobs() {
			return [
				...(this.loadedJobs?.length ? this.loadedJobs.slice(0, 10) : [{
					id: 'nojobs'
				}]),
				{
					id: 'journal'
				}
			]
		},
		hasAnyProcessing() {
			return this.loadedJobs.some(f => f.Status === 2);
		}
	},
	mounted() {
		if (__DEBUG__)
			window.persistentScheduleNotifierItem = this;
		this.loadData();
		this.$eventsBus.$on('signalr-on-notification', this.signalrOnNotification);
		this.$eventsBus.$on('show-persistent-job-details', this.openJob);
	},
	destroyed() {
		this.$eventsBus.$off('signalr-on-notification', this.signalrOnNotification);
		this.$eventsBus.$off('show-persistent-job-details', this.openJob);
	},
	methods: {
		signalrOnNotification({ eventName, data }) {
			if (eventName === 'PersistentJobEntity.StatusChanged') {
				var existsJob = this.loadedJobs.find(f => f.Oid === data?.Oid);
				if (existsJob) {
					_.assign(existsJob, data);
				} else {
					this.loadedJobs.splice(0, 0, this.prepareJob(data));
				}
			}
		},
		getStatusByValue(val, statuses) {
			return val === 2 ? statuses[1] : (val === 3 ? statuses[3] : (val === 4 ? statuses[2] : statuses[0]));
		},
		openAllJobs() {
			this.$router.push({ path: '/persistent-job/List' });
		},
		prepareJob(f) {
			const resultJson = (f.ResultJson && JSON.parse(f.ResultJson) || {});
			const statusData = (f.StatusData && JSON.parse(f.StatusData) || {});
			f.ResultCreativeId = (resultJson.ProcessedObjects || [])[0]?.ProcessedObjectId;
			f.ResultError = statusData?.ExceptionMessage;
			f.Description = f.Name || f.Code || this.$tCaption('Job');
			f.Date = this.$moment(f.StatusChangedAt).format('LLL');
			f.isJob = true;

			return f;
		},
		loadData() {
			const filterCriteria = `&filterCriteria=['StatusChangedAt', '>=', '${this.$moment().add('days', -1).format('YYYY-MM-DD')}']`;

			this.isLoading++;
			return this.$Data.getExternalApi('PersistentJobEntity/List', `page=${1}${filterCriteria}&sorting=[{ selector: 'StatusChangedAt', desc: true }]`, 10)
				.then(r => {
					if (r.Results?.length) {
						r.Results.map(f => this.prepareJob(f));
					}
					this.loadedJobs = r?.Results || [];
					return r;
				})
				.finally(() => this.isLoading--);
		},
		openObject(creativeId) {
			const routeData = this.$router.resolve({ path: `/creative/Detail/${creativeId}` });
			window.open(routeData.href, '_blank');
		},
		openJob(data) {
			this.editingJob = data;
			this.editingJobPopupVisible = false;
			this.$nextTick(() => this.editingJobPopupVisible = true);
		}
	}
};
</script>
<style lang="scss">
	@import "main/themes/generated/variables.base.scss";
	.persistent-schedule-menu-notifier {
		position: relative;
		cursor: pointer;
		transition: 0.3s;
		transform: scale(1);
	
		&:hover{
			transform: scale(1.1);
		}

		.job-notification-icon {
			width: 18px;
			height: 22px;
			opacity: 0.25;
			transition: 0.3s;
			margin-bottom: 2px;
			font-size: 18px;

			&.active, &:hover {
				opacity: 1;
			}
		}

		.messages-indicator {
			position: absolute;
			right: -2px;
			top: -2px;
			padding: 0px;
			height: 0px;
			background: #f27649;
			border-radius: 30px;
			font-size: 10px;
			transition: 0.3s;
			overflow-y: hidden;
			color: $base-bg;
			pointer-events: none;

			&.active {
				height: 14px;
				padding: 4px;
			}
		}
	}
</style>
